module.exports = __webpack_public_path__ + "static/media/agenda23.954fd661.jpeg";